import { Slide } from 'react-awesome-reveal';
import { useReducer } from 'react';
import SlideShow from '../component/slideShow';
import Accomodation from '../images/accomodation.png';
import Accreditation from '../images/accreditation.png';
import Membership from '../images/membership.png';
import Registration from '../images/registration.png';
import AioSystem from '../images/aiosystem.png';
import Epca from '../images/epca.png';
import EventFactory from '../images/eventsfactory.png';
import SmartEvent from '../images/smartevent.png';
import EventApp from '../images/EventApp.png';
import RhWebsite from '../images/rh-website.png';
import Minuza from '../images/minuza.png';
import DigitalBanking from '../images/digital-banking.png';
import MinuzaMobile from '../images/minuza-mobile.png';
import FunPortfolio from '../images/fun-portofolio.png';
import BrdMobile from '../images/brd-mobile banking.png';

const Projects = () => {
  const slides = [
    {
      title: 'Registration System',
      subtitle: 'Events Factory',
      description: 'A coordination of various services, skilled team and dependable secured software systems are employed to provide an event that will leave a mark and not forgotten. Wanna give it a try, send us your details.',
      image: Registration,
      livePreview: 'https://register.smartevent.rw',
      technologies: ['Next.js', 'Nx', 'NestJS', 'Microservices', 'PostgreSQL', 'BullMQ', 'Redis', 'i18n'],
    },
    {
      title: 'Accommodation System',
      subtitle: 'Events Factory',
      description: 'A system that allows people from all over the world to book hotels and facilitate online payment when attending an event in Rwanda',
      image: Accomodation,
      livePreview: 'https://smartbookings.rw',
      technologies: ['PHP', 'HTML5', 'CSS', 'JavaScript', 'Jquery', 'Bootstrap'],
    },
    {
      title: 'Accreditation System',
      subtitle: 'Events Factory',
      description: 'A system that produces badges and gives access to specific people in the specific session and records the attendances',
      image: Accreditation,
      livePreview: 'https://accreditation.smartevent.rw',
      technologies: ['PHP', 'HTML5', 'CSS', 'JavaScript', 'Jquery', 'Bootstrap'],
    },
    {
      title: 'Membership System',
      subtitle: 'Events Factory',
      description: 'Software that provides the African Insurance Organisation with the functionality they require to provide their services to their members like registration, payment, etc.',
      image: Membership,
      livePreview: 'https://membership.african-insurances.org/Auth/SigIn',
      technologies: ['PHP', 'HTML5', 'CSS', 'JavaScript', 'Jquery', 'Bootstrap'],
    },
    {
      title: 'African Insurance Organisation',
      subtitle: 'Events Factory',
      description: 'A website for The African Insurance Organisation (AIO), established in 1972, is a non-governmental organisation recognised by many African governments.',
      image: AioSystem,
      livePreview: 'https://african-insurance.org',
      technologies: ['PHP', 'HTML5', 'CSS', 'JavaScript', 'Jquery', 'Bootstrap'],
    },
    {
      title: 'EPC Africa Group',
      subtitle: 'Events Factory',
      description: 'A website for The EPC Africa Group is a private structure of several companies, with the Head Office based in Kigali-Rwanda.',
      image: Epca,
      livePreview: 'https://epcafrica.com',
      technologies: ['HTML5', 'CSS', 'JavaScript', 'Jquery', 'Bootstrap'],
    },
    {
      title: 'Events Factory',
      subtitle: 'Events Factory',
      description: 'A website for Events Factory a full service events management company who assess the needs of our clients and offer befitting solutions.',
      image: EventFactory,
      livePreview: 'https://eventsfactory.rw',
      technologies: ['React.JS', 'CSS', 'JavaScript', 'Redux', 'Bootstrap'],
    },
    {
      title: 'Smart Events',
      subtitle: 'Events Factory',
      description: 'A website for full service events management company who assess the needs of our clients and offer befitting solutions.',
      image: SmartEvent,
      livePreview: 'https://eventsfactory.rw',
      technologies: ['Next.js', 'React', 'TypeScript', 'Tailwind CSS'],
    },
    {
      title: 'Smart Events App',
      subtitle: 'Events Factory',
      description: 'A mobile application for full service events management company who assess the needs of our clients and offer befitting solutions.',
      image: EventApp,
      livePreview: 'https://eventsfactory.rw',
      technologies: ['React Native', 'JavaScript', 'Tailwind CSS', 'NestJs'],
    },
    {
      title: 'Raisonnances Humanistes',
      subtitle: 'Franco-Moroccan Platform',
      description: 'An independent Franco-Moroccan public policy platform.',
      image: RhWebsite,
      livePreview: 'https://raisonnances-humanistes.org/',
      technologies: ['HTML5', 'Tailwind CSS'],
    },
    {
      title: 'Minuza',
      subtitle: 'Development Bank of Rwanda',
      description: 'Development Bank of Rwanda through its Education financing department intervenes through education and infrastructure financing and efficient management of student loan and bursary schemes for tertiary education within and outside of Rwanda.',
      image: Minuza,
      livePreview: 'https://minuza.brd.rw/',
      technologies: ['Node.js', 'React', 'CSS', 'Tailwind CSS'],
    },
    {
      title: 'Digital Banking for BRD',
      subtitle: 'Development Bank of Rwanda',
      description: 'Experience secure, convenient, and modern banking with the Development Bank of Rwanda. Manage your accounts, loans, and investments all in one place.',
      image: DigitalBanking,
      livePreview: 'https://online.brd.rw',
      technologies: ['Next.js', 'Nx', 'NestJS', 'Microservices', 'PostgreSQL', 'Kafka', 'Redis'],
    },
    {
      title: 'Minuza Mobile App',
      subtitle: 'Development Bank of Rwanda',
      description: 'The Development Bank of Rwanda\'s Education Financing Department is a pivotal player in promoting education and infrastructure development within Rwanda and facilitating access to tertiary education globally. By providing affordable financing options, such as low-interest loans and scholarships, the department empowers Rwandan students to pursue higher education without overwhelming financial constraints.',
      image: MinuzaMobile,
      livePreview: 'https://play.google.com/store/apps/details?id=com.minuza&pli=1',
      technologies: ['React Native', 'JavaScript', 'Tailwind CSS', 'NestJS'],
    },
    {
      title: 'Windows XP Portfolio',
      subtitle: 'Personal Project',
      description: 'A nostalgic trip back to the early 2000s — my personal portfolio reimagined as a fully interactive Windows XP desktop. Complete with draggable windows, a start menu, and classic UI elements, this fun project proves that the best way to showcase your skills is with a little creativity and a lot of personality.',
      image: FunPortfolio,
      livePreview: 'https://aime-m.netlify.app/',
      technologies: ['React', 'JavaScript', 'CSS'],
    },
    {
      title: 'BRD Mobile Banking',
      subtitle: 'Development Bank of Rwanda',
      description: 'The BRD App makes managing your finances easy and secure. Access your account, track loans, receive real-time notifications, apply for BRD products, and get support — all in one place. With secure login, identity verification, and seamless document uploads, staying in control of your financial journey has never been simpler.',
      image: BrdMobile,
      livePreview: 'https://play.google.com/store/apps/details?id=com.brd.developmentbankofrwanda&hl=en',
      technologies: ['React Native', 'NestJS', 'PostgreSQL', 'Redis'],
    },
  ];

  const initialState = {
    slideIndex: 0,
  };

  const slidesReducer = (state, event) => {
    if (event.type === 'NEXT') {
      return {
        ...state,
        slideIndex: (state.slideIndex + 1) % slides.length,
      };
    }
    if (event.type === 'PREV') {
      return {
        ...state,
        slideIndex:
          state.slideIndex === 0 ? slides.length - 1 : state.slideIndex - 1,
      };
    }
    return state;
  };
  const [state, dispatch] = useReducer(slidesReducer, initialState);
  return (
    <Slide direction="left">
      <div className="w-screen h-screen relative z-50 pl-20 pr-36 py-20 page-layout-responsive">
        <div className="bg-slate-50 dark:bg-slate-800 w-full h-full rounded-xl p-10 overflow-hidden">
          <div className="mb-5">
            <p className="text-slate-500 text-lg text-center">Showcasing some of my best work</p>
            <h1 className="text-black dark:text-white font-bold text-center text-5xl my-4">
              My
              <span className="colored-main-left">
                Projects
              </span>
            </h1>
            <div className="animated-bar" />
          </div>
          <div className="slide-body">
            <div className="slides">
              <button type="button" onClick={() => dispatch({ type: 'NEXT' })}>‹</button>
              {[...slides, ...slides, ...slides].map((slide, i) => {
                const offset = slides.length + (state.slideIndex - i);
                return <SlideShow offset={offset} slide={slide} key={`${slide.title}-${offset}`} style={{ backgroundImage: `url('${slide.image}')`, loading: 'lazy' }} />;
              })}
              <button type="button" onClick={() => dispatch({ type: 'PREV' })}>›</button>
            </div>
          </div>
          <div className="flex justify-center projects-liks-buttons">
            <a href={slides[state.slideIndex].livePreview} target="blanc" className="rounded-lg text-center w-1/5 button-link">Live Preview</a>
          </div>
        </div>
      </div>
    </Slide>
  );
};

export default Projects;
